/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package onboarding.domain.interactor

class PasswordIsNotValidException : Exception(message = "Password is not valid.")